import type { FrontModule } from "@core/modules";
import "./decision.css";
import { CandidateConsents, CandidateCorrections, CandidateDecision, CandidateGuarantees, CandidateGuidedChecks } from "./candidate";
import { ContestationsPage } from "./ContestationsPage";
import { CorrectionsTab } from "./CorrectionsTab";
import { DecisionDashboard } from "./Dashboard";
import { DecisionTab } from "./DecisionTab";
import { DossierFacileTab } from "./DossierFacileTab";
import { GuaranteesTab } from "./GuaranteesTab";
import { EmployerConfirmationPage, GuarantorCommitmentPage } from "./public";
import { VerificationsTab } from "./VerificationsTab";

// Module « decision » : décision humaine et contestation, corrections, confirmation employeur, Mes droits sociaux,
// identité, garants, Visale, garanties loyers impayés, import DossierFacile.
export const module: FrontModule = {
  name: "decision",
  orgRoutes: [{ path: "contestations", element: <ContestationsPage /> }],
  nav: [{ to: "contestations", label: "Contestations", section: "Location", perm: "read", order: 40 }],
  publicRoutes: [
    { path: "/confirmation-employeur/:token", element: <EmployerConfirmationPage /> },
    { path: "/engagement-garant/:token", element: <GuarantorCommitmentPage /> },
  ],
  Dashboard: DecisionDashboard,
  applicationTabs: [
    { id: "decision", label: "Décision", order: 80, Component: DecisionTab },
    { id: "garanties", label: "Garanties", order: 70, Component: GuaranteesTab },
    { id: "verifications-externes", label: "Vérifications externes", order: 60, Component: VerificationsTab },
    { id: "corrections", label: "Corrections", order: 65, Component: CorrectionsTab },
  ],
  candidateSections: [
    { id: "decision", label: "Décision et échanges", order: 20, Component: CandidateDecision },
    { id: "corrections", label: "Corrections demandées", order: 30, Component: CandidateCorrections },
    { id: "garanties", label: "Mes garanties", order: 60, Component: CandidateGuarantees },
    { id: "consentements", label: "Consentements", order: 70, Component: CandidateConsents },
    { id: "identite-activite", label: "Identité et activité", order: 75, Component: CandidateGuidedChecks },
  ],
  campaignTabs: [{ id: "dossierfacile", label: "Importer depuis DossierFacile", order: 80, Component: DossierFacileTab }],
};
